import { useAgentTransport } from "@/agents/transport"

interface AgentBreadcrumbContentProps {
  agentId: string
  isLast: boolean
}

export const AgentBreadcrumbContent = ({
  agentId,
  isLast,
}: AgentBreadcrumbContentProps) => {
  const { data: agent, error } = useAgentTransport(agentId)
  const displayName = agent?.display_name || (agent || error ? "Agent" : null)

  return (
    <span className={isLast ? "font-semibold" : ""}>
      {displayName ?? <span className="sr-only">Agent</span>}
    </span>
  )
}
